import React from 'react';
import { Link } from 'react-router-dom';
import { usePageTitle } from '../../hooks/usePageTitle';
import FeedbackForm from './FeedbackForm';

// issue #162: ヘルプ画面 (中身は見出し + 要望フォームのみ)。
// トップ (FingeringPage) フッターの「ヘルプ・ご要望」導線から遷移してくる。
const HelpPage: React.FC = () => {
  usePageTitle('ヘルプ・ご要望 | おまかせ運指くん');
  return (
    <div className="max-w-2xl mx-auto py-8 px-4">
      <header className="mb-6 text-center">
        <h1 className="text-2xl md:text-3xl font-bold text-brand-purple mb-2">ヘルプ・ご要望</h1>
        <p className="text-slate-600 text-sm md:text-base leading-relaxed">
          使っていて困ったこと・「こうしてほしい」があれば、こちらからお送りください。
        </p>
      </header>

      <FeedbackForm />

      <div className="text-center mt-6">
        <Link to="/fingering" className="text-sm text-slate-500 hover:text-slate-700 underline">
          ← 運指生成にもどる
        </Link>
      </div>
    </div>
  );
};

export default HelpPage;
